<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';
	import Section from '$lib/components/fragments/Section.svelte';
	import TobaccoChart from '$lib/components/charts/TobaccoChart.svelte';
	import Headline from '$lib/components/fragments/Headline.svelte';

	const copy = $derived(getCopy().tobacco);
</script>

<Section id="tobacco" class="bg-blue text-white">
	<div class="content-well-sm">
		<Headline overline={copy.overline} title={copy.title} dark />
		<p class="body-1">{@html md(copy.copy_before)}</p>
	</div>

	<TobaccoChart />

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_after)}</p>
	</div>
</Section>
